import resetReducer from './reset'
import saveErrorReducer from './save-error'
import saveReducer from './save'
import saveSuccessReducer from './save-success'
import setReducer from './set'
import { updateReduxReducer } from '@gymaholic/packages/src/modules/redux/reducers/update'
import REDUX_ACTION from 'modules/redux/constants/action'
import { loadSuccessReduxReducer } from 'modules/redux/reducers/load-success'
import { loadReduxReducer } from 'modules/redux/reducers/load'
import { loadErrorReduxReducer } from 'modules/redux/reducers/load-error'

export default {
  [REDUX_ACTION.UPDATE]: updateReduxReducer,
  [REDUX_ACTION.RESET]: resetReducer,
  [REDUX_ACTION.LOAD]: loadReduxReducer,
  [REDUX_ACTION.LOAD_ERROR]: loadErrorReduxReducer,
  [REDUX_ACTION.LOAD_SUCCESS]: loadSuccessReduxReducer,
  [REDUX_ACTION.SAVE]: saveReducer,
  [REDUX_ACTION.SAVE_ERROR]: saveErrorReducer,
  [REDUX_ACTION.SAVE_SUCCESS]: saveSuccessReducer,
  [REDUX_ACTION.SET]: setReducer
}
